import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import imgIconoLogin from "../assets/images/avatar.png";
import logoCentenario from "../assets/images/home/logo_centenario_2_f.png";
import axios from "axios";
import { HiOutlineChevronDoubleLeft, HiOutlineChevronDoubleRight } from "react-icons/hi";
import { useLocalStorage } from "../useLocalStorage";

const Header = ({ user, onLogout }) => {
  
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useLocalStorage("isSidebarOpen", true);
  const [nameReport, setnameReport] = useState(null);
  //const [nameReport, setnameReport] = useLocalStorage('nameReport',null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [hasaccess,setHasaccess] = useState(false);
  const [hasaccessSteward,setHasaccessSteward] = useState(false);
  //const servidor = "http://localhost:3000";
  const servidor = "https://analytics.centenario.com.pe";
  var bvisible = false;


    const fetchData = async () => {
      try {
        const response = await axios.get(`${servidor}/api/rolesusuario?correo=${user.email}`);
        
        const tieneAccesoAdmin = (response.data[0].RolID === 1 ? true : false);

        const tieneAccesoSteward = (response.data[0].RolID === 2 ? true : false);

        setHasaccess(tieneAccesoAdmin);

        if(tieneAccesoAdmin)
        {
          //Si es administrador asigna a todos true
          setHasaccessSteward(true);
        }else
        {
          setHasaccessSteward(tieneAccesoSteward);
        }
         
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };


        useEffect(() => {
            fetchData(); //verifica si el acceso tiene permisos de administrador
        },[hasaccess])

  useEffect(() => {
        localStorage.removeItem("nameReport");
        setnameReport(null);

        const handleStorageChange = () => {
          const storedValue = localStorage.getItem("nameReport");
          setnameReport(JSON.parse(storedValue));
        };
      
        // Establecer el estado inicial basado en localStorage
        handleStorageChange();
        
        window.addEventListener("storage_name", handleStorageChange);
        return () => window.removeEventListener("storage_name", handleStorageChange);

        
      }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => setIsFullscreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false));
    }
  };

  const toggleRedirectAdminWorkSpace = () => {
      navigate("/mainworkspace");
  };

   const toggleRedirectAdminPipeline = () => {
      navigate("/manager");
  };

     const toggleRedirectAdminNews = () => {
      navigate("/newsmanager");
  };

   const toggleRedirectNews = () => {
      window.location.reload();
  };
    const toggleRedirectAdminprojects = () => {
      navigate("/projects");
  };

  return (
    <Navbar bg="light" expand="lg" className="shadow-sm fixed-top" style={{ height: "60px" }}>
      <Container fluid>
        {/* Botón Sidebar */}
        <button className="btn btn-danger me-3" onClick={toggleSidebar}>
          {isSidebarOpen ? <HiOutlineChevronDoubleLeft size={24} /> : <HiOutlineChevronDoubleRight size={24} />}
        </button>

        {/* Logo */}
        <Navbar.Brand href="/" className="me-auto">
          <img src={logoCentenario} alt="Logo" style={{ width: "120px", height: "auto" }} />
        </Navbar.Brand>

        {/* Título centrado en pantallas grandes */}
        <div className="d-none d-lg-block position-absolute start-50 top-50 translate-middle">
          
          {nameReport ? <h5 className="fw-bold mb-0" style={{color:"#d32f2f"}}>{nameReport}</h5> : ""}
        </div>

        {/* Menú Responsive */}
        <Navbar.Toggle aria-controls="navbar-menu" />
        <Navbar.Collapse id="navbar-menu" className="justify-content-end">
          <Nav className="ms-auto w-auto text-end">
            {user ? (
              <NavDropdown
                title={<img src={imgIconoLogin} alt="User" className="rounded-circle" style={{ width: "30px", height: "30px" }} />}
                id="user-dropdown"
                align="end"
              >
                <NavDropdown.Item onClick={toggleFullscreen}>{isFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}</NavDropdown.Item>
                { hasaccess ? (<NavDropdown.Item onClick={toggleRedirectAdminWorkSpace}>Administración de WorkSpace</NavDropdown.Item>) : ""}
                { hasaccess ? (<NavDropdown.Item onClick={toggleRedirectAdminPipeline}>Administración de Pipelines</NavDropdown.Item>) : ""}
                { hasaccessSteward ? (<NavDropdown.Item onClick={toggleRedirectAdminprojects}>Administración de Proyectos CDU</NavDropdown.Item>) : ""}
                { hasaccess ? (<NavDropdown.Item onClick={toggleRedirectAdminNews}>Administración de Anuncios</NavDropdown.Item>) : ""}
                <NavDropdown.Item onClick={onLogout}>Cerrar sesión</NavDropdown.Item>
                
              </NavDropdown>
            ) : (
              <Nav.Link href="/login">Iniciar sesión</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;